import { memo } from 'react';
import classNames from 'classnames';

export interface LabelProps {
	title: string;
	className?: string;
}

const Label = ({ title, className }: LabelProps) => (
	<span className={classNames('label-wrapper', className)}>{title}</span>
);

export default memo(Label);
